import * as yup from 'yup';

export const addressSchema = yup.object({
	addressId: yup.string().required(),
	addressType: yup.string().oneOf(['Shipping', 'Billing']).required(),
	apartment: yup.string().optional(),
	area: yup.string().required(),
	city: yup.string().required(),
	governorate: yup.string().required(),
	house: yup.string().optional(),
	landmark: yup.string().optional(),
	markerPosition: yup
		.object({
			lat: yup.number().optional(),
			lng: yup.number().optional(),
		})
		.optional(),
	nickName: yup.string().optional(),
	organization: yup.string().optional(),
	way: yup.string().optional(),
	wilayat: yup.string().required(),
	zipCode: yup.string().optional(),
});
